export const buildTapCardDetails = (response) => {
    const card = response?.card ?? response?.source?.card;
    if (!card) return null;
    const digits =
        card.first_eight ??
        card.first_eight_digits ??
        card.first_six ??
        card.first_six_digits;
    if (digits == null || digits === "") return null;
    return { first_eight_digits: String(digits) };
};

export const handleUserInfo =  (response) => {
    let data =  {
        name: response.user != undefined && response.user.name != undefined ? response.user.name : null,
        email: response.user == null ? response.email : response.user != undefined && response.user.email != undefined ? response.user.email : null,
        userId: response.user != undefined && response.user.id != undefined ? response.user.id : null,
        number: response.user != undefined && response.user.number != undefined ? response.user.number : null,
        countryCode: response.user != undefined && response.user.country_code != undefined ? response.user.country_code : null,
        emailVerfiy: response.user != undefined && response.user.email_verified_at != undefined ? response.email_verified_at : null,
        walletAmount: response.wallet != undefined && response.wallet.amount != undefined ? response.wallet.amount : null,
        walletCreated: response.wallet != undefined && response.wallet.created_at != undefined ? response.wallet.created_at : null,
        walletDeleted: response.wallet != undefined && response.wallet.deleted_at != undefined ? response.wallet.deleted_at : null,
        walletId: response.wallet != undefined && response.wallet.id != undefined ? response.wallet.id : null,
        walletReward: response.wallet != undefined && response.wallet.reward != undefined ? response.wallet.reward : null,
        walletUpdated: response.wallet != undefined && response.wallet.updated_at != undefined ? response.wallet.updated_at : null,
        tapWalletId: response.meta != undefined && response.meta.tap_wallet_id != undefined ? response.meta.tap_wallet_id : null,
        tapBankId: response.meta != undefined && response.meta.tap_bank_account_id != undefined ? response.meta.tap_bank_account_id : null,
        tapCustomerId: response.tap_customer_id != undefined ? response.tap_customer_id : null,
        userInvoices: response.invoices != undefined && response.invoices.count != undefined ? response.invoices.count : null,
        userActiveStatus: response.active.status != undefined ? response.active.status : null,
        userActiveReason: response.active.reason != undefined ? response.active.reason : null,
        userCreated: response.created_at != undefined ? response.created_at : null,
        userCurrency: response.currency != undefined ? response.currency : null,
        userDob: response.dob != undefined ? response.dob : null,
        userFirstName: response.first_name != undefined ? response.first_name : null,
        userLastName: response.last_name != undefined ? response.last_name : null,
        userMiddleName: response.middle_name != undefined ? response.middle_name : null,
        userNationality: response.nationality != undefined ? response.nationality : null,
        userToken: response.token != undefined ? response.token : null,
        userGender: response.gender != undefined ? response.gender : null,
        userCountryId: response.country_id != undefined ? response.country_id : null,
        userCityId:  response.city_id != undefined ? response.city_id : null,
        userAreaId: response.area_id != undefined ? response.area_id : null,
        userAddress: response.address != undefined ? response.address : null,
        customerId: response.id != undefined ? response.id : null,
        userImage: response.image != undefined ? response.image : null,
    }
    return data;
    }


const DEFAULT_CURRENCY = "KWD";

const CURRENCY_ALIASES = {
  KW: "KWD",
  SA: "SAR",
  AE: "AED",
  BH: "BHD",
  OM: "OMR",
  QA: "QAR",
  IR: "IRR",
  PK: "PKR",
  IN: "INR",
};

export const currencyMap = {
  KWD: { symbol: null, code: "KWD", name: { en: "KWD", ar: "د.ك" } },
  OMR: { symbol: null, code: "OMR", name: { en: "OMR", ar: "ر.ع." } },
  BHD: { symbol: null, code: "BHD", name: { en: "BHD", ar: "د.ب" } },
  IRR: { symbol: "﷼", code: "IRR", name: { en: "IRR", ar: "﷼" } },
  SAR: { symbol: "⃁", code: "SAR", name: { en: "SAR", ar: "⃁" } },
  AED: { symbol: null, code: "AED", name: { en: "AED", ar: "د.إ" } },
  QAR: { symbol: null, code: "QAR", name: { en: "QAR", ar: "ر.ق" } },
  PKR: { symbol: null, code: "PKR", name: { en: "PKR", ar: "ر.پ" } },
  INR: { symbol: "₹", code: "INR", name: { en: "INR", ar: "₹" } },
  USD: { symbol: "$", code: "USD", name: { en: "USD", ar: "USD" } },
  EUR: { symbol: "€", code: "EUR", name: { en: "EUR", ar: "EUR" } },
  GBP: { symbol: "£", code: "GBP", name: { en: "GBP", ar: "GBP" } },
  CAD: { symbol: "CA$", code: "CAD", name: { en: "CAD", ar: "CAD" } },
  AUD: { symbol: "A$", code: "AUD", name: { en: "AUD", ar: "AUD" } },
  NZD: { symbol: "NZ$", code: "NZD", name: { en: "NZD", ar: "NZD" } },
};

export const normalizeCurrencyCode = (currencyCode) => {
  if (currencyCode == null || currencyCode === "") return DEFAULT_CURRENCY;
  const upper = String(currencyCode).trim().toUpperCase();
  return CURRENCY_ALIASES[upper] ?? upper;
};

export const getCurrencyEntry = (currencyCode) => {
  const key = normalizeCurrencyCode(currencyCode);
  return currencyMap[key] ?? currencyMap[DEFAULT_CURRENCY];
};

/** Localized currency label for display (en / ar). Prefers symbol, else name[lang]. */
export const getCurrencyLabel = (currencyCode, langValue = "en") => {
  const entry = getCurrencyEntry(currencyCode);
  const lang = langValue === "ar" ? "ar" : "en";

  if (entry?.symbol != null && String(entry.symbol).trim() !== "") {
    return String(entry.symbol).trim();
  }

  const localized = entry?.name?.[lang];
  if (localized != null && String(localized).trim() !== "") {
    return String(localized).trim();
  }

  return entry?.code ?? DEFAULT_CURRENCY;
};

/**
 * Format amount with currency. Symbol currencies: "⃁ 39.000" (always before).
 * Name-only currencies: "39.000 KWD" / "39.000 د.ك".
 */
export const formatMoney = (amount, currencyCode, langValue = "en", decimals = 3) => {
  const entry = getCurrencyEntry(currencyCode);
  const n = Number(amount);
  const value = Number.isFinite(n) ? n.toFixed(decimals) : (0).toFixed(decimals);
  const lang = langValue === "ar" ? "ar" : "en";
  const hasSymbol = entry?.symbol != null && String(entry.symbol).trim() !== "";

  if (hasSymbol) {
    return `${String(entry.symbol).trim()} ${value}`;
  }

  const label = entry?.name?.[lang] || entry?.code || DEFAULT_CURRENCY;
  return `${value} ${label}`;
};